module.exports = __webpack_public_path__ + "media/images/mock-thumbs/event-3-45ddbc2e3736aaec5b85410cb3ccdab4.png";